import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

import type { TextAreaProps } from './TextArea';

import {
  getInputBackgroundColor,
  getInputBorderColor,
} from '../Input/Input.styles';

export const Wrapper = styled(Flex)<{ disabled: boolean }>`
  width: 100%;
  height: auto;
  position: relative;
`;

export const TextArea = styled.textarea<
  Pick<TextAreaProps, 'borderColorVariant' | 'colorVariant'> & {
    error: boolean;
  }
>`
  flex: 1;
  border: none;
  resize: none;

  ${({ borderColorVariant, colorVariant, error, theme }) => css`
    padding-top: ${theme.spacing(2)};
    padding-left: ${theme.spacing(1.25)};
    border-bottom: 1px solid
      ${error ? theme.colors.error : getInputBorderColor(borderColorVariant)};
    background: ${getInputBackgroundColor(colorVariant)};
  `}
`;
